export default __webpack_public_path__ + "static/media/bank-jcb.e6b10730.svg";